<template>
  <div class="product-form-drawer" >
    <div class="product-form-drawer__masthead">
      <div
        class="product-form-drawer__progress"
        :style="{ 'width': getProgressPercent() }"
      />
      <button
        v-if="currentStep > 1"
        class="
            text-heading-s
            button
            button--text
            button--text--dark
            button-reversed
            product-form-drawer__toggle"
        type="button"
        @click="handleStepProgress('prev')"
      >
        <icon-chevron-left />
        <span v-text="$string('general.menu_drawer.back_to')" />
      </button>

      <h2
        class="text-heading-l"
        v-text="product.title"
      />

      <button
        class="
          overlay__close-container
          icon-button
          product-form-drawer__close
        "
        type="button"
        :aria-label="$string('accessibility.close')"
        @click.prevent="closeOverlay('productPurchaseDrawer')"
      >
        <close />
      </button>
    </div>

    <div
      class="product-form-drawer__body"
      js-overlay="scrollElement"
    >
      <div class="product-form-drawer__body-content">
        <div
          v-show="currentStep === 1"
          class="product-form-drawer__step mt-s-desktop"
        >
          <div class="product-form-drawer__step-header">
            <div class="product-form-drawer__title">
              <h3
                class="text-heading-xl text-heading-2xl-desktop product-form-drawer__title"
                v-text="$string('product.sidebar.power')"
              />
            </div>
          </div>

          <div class="product-form-drawer__options">
            <div
              v-for="(variant, index) of localizedVariants"
              :key="index"
              class="product-form-drawer__option-box"
             
            >
            <h3 class="line-item__title text-heading-m my-s" > {{ variant.variantTitle }} </h3>
            <h3 class="line-item__title product-form-drawer__option_box_new_title text-heading-m " v-if="variant.variantEngine">  {{ variant.variantEngine }} </h3>
          <div class="product-form-drawer__option-boxes "  :class="{
                [$class('active')]: selectedProduct?.id === variant.id 
              }"
               :data-id="variant.id"
               @click="handleVariantSelection(variant)">
          <div  class="product-form-drawer__variant-engine" :class="{
                'product-form-drawer__option' : variant.variantEngine == null
              }"
             >
              <div class="product-form-drawer__option-innercontent">
              <div class="product-form-drawer__option-header">
                <h3 class="line-item__title text-heading-m">
                  <gas v-if="getVariantType(variant.title) === 'gas'" />
                  <electric
                    v-if="getVariantType(variant.title) === 'electric'"
                  />
                  {{ sanitizeTitle(variant.title) }}
                </h3>

                <product-prices
                  class="line-item__price"
                  class-price="text-heading-m"
                  :price="variant.price.amount"
                  :compare-at-price="variant.compareAtPrice.amount"
                />
              </div>

              <p
                class="text-body-s-regular mt-s"
                v-text="sanitizeDescription(variant.title)"
              />
            </div>
            </div>
         
            <span class="product-form-drawer__leadtime-step" v-if="variant.leadTime">
              <img v-if="variant.leadtimeicon" :src="variant.leadtimeicon" alt="leadtimeicon" height="20" width="30"   loading='lazy'>
              <span class="text-body-s-regular product-form-drawer__leadtime_text" v-text="variant.leadTime" ></span>
            </span>
          </div>
           </div>
          </div>
        </div>

        <div
          v-show="currentStep === 2"
          class="product-form-drawer__step mt-s-desktop"
        >
          <div class="product-form-drawer__step-header">
            <div class="product-form-drawer__title">
              <span
                class="product-form-drawer__step-count text-heading-s"
              >
                {{ currentStep }}/{{ steps }}
              </span>
              <h2
                class="text-heading-xl text-heading-2xl-desktop"
                v-text="$string('product.sidebar.package')"
              />
            </div>

            <span
              class="product-form-drawer__optional text-heading-s"
              v-text="$string('product.sidebar.optional')"
            />
          </div>

          <p
            class="text-body-s-regular mt-s"
            v-text="$string('product.sidebar.package_copy')"
          />
          <h3 v-if="$string('product.sidebar.estimate_description') !== 'No string found'  "
              class="text-body-s-regular mt-s"
              v-text="$string('product.sidebar.estimate_description')"
            />
          <div class="product-form-drawer__options">
            <div
              v-for="(bundle, index) of product.bundles.variants"
              :key="index"
              class="product-form-drawer__option"
              :class="{
                [$class('active')]: isSelectedBundle(bundle),
                [$class('disabled')]: !bundle.available,
              }"
              :data-id="bundle.id"
            >
              <div
                class="product-form-drawer__option-header"
              >
                <checkbox-input
                  :id="`bundle-${bundle.id}`"
                  :checked="isSelectedBundle(bundle)"
                  :label="bundle.title"
                  :disabled="!bundle.available"
                  label-class="text-heading-m product-form-drawer__option-title"
                  :value="bundle.id"
                  @update:model-value="bundle.available ? handleBundleSelection(bundle) : {}"
                />

                <product-prices
                  class="line-item__price"
                  sawmill="line-item__price"
                  class-price="text-heading-m"
                  :price="bundle.price.amount"
                  :compare-at-price="bundle.compareAtPrice.amount"
                />
              </div>
            
              <div class="product-form-drawer__option-content">
                <div class="product-form-drawer__option-copy">
                  <p
                    class="text-body-s-regular"
                    v-text="bundle.description"
                  />
                  <span class="product-form-drawer__leadtime mt-s">
                    <img v-if="bundle.leadtimeicon" :src="bundle.leadtimeicon" alt="leadtimeicon" height="20" width="27">
                    <span class="text-body-s-regular product-form-drawer__leadtime_text" v-text="bundle.leadTime" ></span>
                  </span>
                  <p
                    class="product-form-drawer__option-items text-heading-s mt-l"
                    @click="toggleAccordion(bundle.id)"
                  >
                    <plus v-if="activeAccordion !== bundle.id" />
                    <minus v-else />
                    {{$string('product.sidebar.whats_included')}}
                  </p>

                  <transition-height>
                    <ul v-show="activeAccordion === bundle.id">
                      <li
                        v-for="(item, bundleIndex) of bundle.products"
                        :key="bundleIndex"
                        class="text-body-s-regular"
                        v-text="item.title"
                      />
                    </ul>
                  </transition-height>
                </div>
                <div class="product-form-drawer__option-image">
                  <responsive-image
                    :image="bundle.image"
                    ratio="4:3"
                    sizes="111px, 78px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="currentStep === 3"
          class="product-form-drawer__step mt-xl-desktop"
        >
          <div v-if="product.giftproducts" class="product-form-drawer__step-header">
            <div class="product-form-drawer__title">
              <span
                class="product-form-drawer__step-count text-heading-s"
              >
                {{ currentStep }}/{{ steps }}
              </span>
              <h2
                class="text-heading-xl text-heading-2xl-desktop"   v-text="$string('product.sidebar.gift')"
              />
             
            </div>
          </div>
          <p v-if="$string('product.sidebar.gift_package') != 'No string found'  "
            class="text-body-s-regular mt-s"
            v-text="$string('product.sidebar.gift_package')"
          />
          <p v-if="$string('product.sidebar.gift_description') != 'No string found'  "
            class="text-body-s-regular mt-s"
            v-text="$string('product.sidebar.gift_description')"
          />
          <div v-if="!product.giftproducts" class="product-form-drawer__step-header">
            <div class="product-form-drawer__title">
              <span
                class="product-form-drawer__step-count text-heading-s"
              >
                {{ currentStep }}/{{ steps }}
              </span>
              <h2
                class="text-heading-xl text-heading-2xl-desktop"
                v-text="$string('product.sidebar.attachment')"
              />
            </div>

            <span
              class="product-form-drawer__optional text-heading-s"
              v-text="$string('product.sidebar.optional')"
            />
          </div>

          <div class="product-form-drawer__options">
            <div v-if="product.giftproducts"
              v-for="(giftproduct, index) of product.giftproducts"
              :key="index"
              class="product-form-drawer__option"
              :class="{
                [$class('active')]: isSelectedGift(giftproduct, index),
                [$class('disabled')]: !giftproduct.available,
              }"
              :data-id="giftproduct.id"
            >
              <div class="product-form-drawer__option-header">
                <checkbox-input
                  :id="`attachment-${giftproduct.id}`"
                  :checked="isSelectedGift(giftproduct, index)"
                  :label="giftproduct.title"
                  label-class="text-heading-m product-form-drawer__option-title"
                  :value="giftproduct.id"
                  @update:model-value="
                    giftproduct.available ? handleGiftSelection(giftproduct, index) : {}
                  "
                />

                <product-prices
                  class="line-item__price"
                  sawmill="line-item__price"
                  class-price="text-heading-m"
                  :price="`0`"
                  :compare-at-price="giftproduct.price.amount"
                />
              </div>
              <div class="product-form-drawer__option-content">
                <div class="product-form-drawer__option-copy">
                  <p
                    class="text-body-s-regular"
                    v-text="giftproduct.description"
                  />
                </div>
                <div class="product-form-drawer__option-image">
                  <responsive-image
                    v-if="giftproduct.featuredImage"
                    :image="giftproduct.featuredImage"
                    ratio="4:3"
                    sizes="111px, 78px"
                  />
                </div>
              </div>

              <div
                class="product-form-drawer__option-select form-group"
              >
                <label
                  v-if="giftproduct.hasOnlyDefaultVariant === false"
                  for="selected-language"
                  v-text="$string('product.sidebar.select_option') + ':'"
                />
                <select
                  v-if="giftproduct.hasOnlyDefaultVariant === false"
                  ref="selectedAttachmentVariant"
                  name="selected_attachment_variant"
                  @change="updateGiftSelection(giftproduct, index)"
                >
                  <option
                    v-for="(variant, variantIndex) of giftproduct.variants"
                    :key="variantIndex"
                    :value="variant.id"
                    :selected="variantIndex === 0"
                    v-text="`${variant.title} - ${$formatMoney(variant.price.amount)}`"
                  />
                </select>

                <input
                  v-else
                  ref="selectedAttachmentVariant"
                  name="selected_attachment_variant"
                  type="hidden"
                  :value="giftproduct.selectedOrFirstAvailableVariant.id"
                >
              </div>
            </div>
            <div v-if="!product.giftproducts "
              v-for="(attachment, index) of product.attachments"
              :key="index"
              class="product-form-drawer__option"
              :class="{
                [$class('active')]: isSelectedAttachment(attachment, index),
                [$class('disabled')]: !attachment.available,
              }"
              :data-id="attachment.id"
            >
              <div class="product-form-drawer__option-header">
                <checkbox-input
                  :id="`attachment-${attachment.id}`"
                  :checked="isSelectedAttachment(attachment, index)"
                  :label="attachment.title"
                  label-class="text-heading-m product-form-drawer__option-title"
                  :value="attachment.id"
                  @update:model-value="
                    attachment.available ? handleAttachmentSelection(attachment, index) : {}
                  "
                />

                <product-prices
                  class="line-item__price"
                  sawmill="line-item__price"
                  class-price="text-heading-m"
                  :price="attachment.price.amount"
                  :compare-at-price="attachment.compareAtPrice.amount"
                />
              </div>
              <div class="product-form-drawer__option-content">
                <div class="product-form-drawer__option-copy">
                  <p
                    class="text-body-s-regular"
                    v-text="attachment.description"
                  />
                </div>
                <div class="product-form-drawer__option-image">
                  <responsive-image
                    v-if="attachment.featuredImage"
                    :image="attachment.featuredImage"
                    ratio="4:3"
                    sizes="111px, 78px"
                  />
                </div>
              </div>

              <div
                class="product-form-drawer__option-select form-group"
              >
                <label
                  v-if="attachment.hasOnlyDefaultVariant === false"
                  for="selected-language"
                  v-text="$string('product.sidebar.select_option') + ':'"
                />
                <select
                  v-if="attachment.hasOnlyDefaultVariant === false"
                  ref="selectedAttachmentVariant"
                  name="selected_attachment_variant"
                  @change="updateAttachmentSelection(attachment, index)"
                >
                  <option
                    v-for="(variant, variantIndex) of attachment.variants"
                    :key="variantIndex"
                    :value="variant.id"
                    :selected="variantIndex === 0"
                    v-text="`${variant.title} - ${$formatMoney(variant.price.amount)}`"
                  />
                </select>

                <input
                  v-else
                  ref="selectedAttachmentVariant"
                  name="selected_attachment_variant"
                  type="hidden"
                  :value="attachment.selectedOrFirstAvailableVariant.id"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="product-form-drawer__footer"
      :class="{ [$class('active')]: subtotal > 0 }"
    >
      <div
        v-show="subtotal > 0"
        class="product-form-drawer__summary"
      >
        <div
          class="product-form-drawer__subtotal"
          :class="{ [$class('active')]: expandSummary}"
          @click="handleExpandSummary"
        >
          <span
            class="text-body-s-regular"
            v-text="$string('cart.summary.subtotal_label')"
          />

          <product-prices
            class="line-item__price"
            sawmill="line-item__price"
            class-price="text-heading-xl"
            :price="subtotal"
            :compare-at-price="false"
          />

          <icon-chevron-down />
        </div>

        <transition-height>
          <div
            v-show="expandSummary && isMobile"
            class="product-form-drawer__line-items"
          >
            <div
              v-for="(lineItem, productIndex) of selectedProducts"
              :key="productIndex"
              class="product-form-drawer__line-item"
            >
              <p class="text-heading-m product-form-drawer__line-item-title">
                <span class="text-heading-m">{{ lineItem.title }}</span><br>
                <span
                  class="text-body-s-regular"
                  v-text="lineItem.variant"
                />
              </p>

              <product-prices
                class="line-item__price"
                sawmill="line-item__price"
                class-price="text-heading-m"
                :price="lineItem.price.amount"
                :compare-at-price="false"
              />
            </div>
          </div>
        </transition-height>

        <btn
          v-if="currentStep !== 3"
          class="product-form-drawer__cta"
          modifiers="fill"
          :label="$string('product.cta.next')"
          hover-only
          @click="handleStepProgress('next')"
        >
          <template #hoverIcon>
            <icon-arrow-right />
          </template>
        </btn>

        <btn
          v-if="currentStep === 3"
          class="product-form-drawer__cta"
          :label="$string('product.cta.add_to_cart')"
          modifiers="fill center"
          hover-only
          type="button"
          @click.prevent="handleAddToCart"
        >
          <template #hoverIcon>
            <icon-cart />
          </template>
        </btn>
      </div>

      <transition-height>
        <div
          v-show="expandSummary && !isMobile"
          class="product-form-drawer__line-items"
        >
          <div
            v-for="(lineItem, productIndex) of selectedProducts"
            :key="productIndex"
            class="product-form-drawer__line-item"
          >
            <p class="text-heading-m product-form-drawer__line-item-title">
              <span class="text-heading-m">{{ lineItem.title }}</span><br>
              <span
                class="text-body-s-regular"
                v-text="lineItem.variant"
              />
            </p>

            <product-prices
              class="line-item__price"
              sawmill="line-item__price"
              class-price="text-heading-m"
              :price="lineItem.price.amount"
              :compare-at-price="false"
            />
          </div>
        </div>
      </transition-height>

      <div v-show="subtotal > 0" class="product-form-drawer__announcement-bar">
        <div class="product-form-drawer__announcement">
          <img v-if="icon" :src="icon" alt="icon" height="27" width="27">
          <p
            class="text-heading-s product-form-drawer__announcement_text"
            v-text="leadtimeValue"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product form drawer (product-form-drawer)
 * -----------------------------------------------------------------------------
 * Sawmill product purchase flow.
 *
 */
import ProductPrices from '~global/product-prices/product-prices'
import IconChevronLeft from '~icons/directional-navigation/chevron/left.svg'
import IconChevronDown from '~icons/directional-navigation/chevron/down.svg'
import IconShipping from '~icons/general/shipping.svg'
import IconCart from '~icons/button/cart.svg'
import IconArrowRight from '~icons/directional-navigation/arrow/right.svg'
import Close from '~icons/directional-navigation/close.svg'
import Plus from '~icons/general/plus.svg'
import Minus from '~icons/general/minus.svg'
import TransitionHeight from '~async/transition-height/transition-height'
import ResponsiveImage from '~global/images/responsive-image'
import CheckboxInput from '~async/utils/checkbox-input/checkbox-input'
import Btn from '~global/btn/btn'
import Gas from '~icons/spec/gas.svg'
import Electric from '~icons/spec/electric.svg'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ProductFormDrawer',
  components: {
    ProductPrices,
    IconCart,
    IconChevronDown,
    IconChevronLeft,
    IconArrowRight,
    IconShipping,
    Plus,
    Minus,
    Btn,
    Close,
    TransitionHeight,
    ResponsiveImage,
    CheckboxInput,
    Gas,
    Electric,
  },
  props: {
    overlay: {
      type: Object,
      default: () => ({}),
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    icon : {
      type: [String],
      default: false,
    },
    leadtimeValue : {
      type : [String],
      default : null 
    }
  },
  data() {
    return {
      steps: 3,
      currentStep: 1,
      selectedProducts: [],
      ships_in_text: null,
      selectedProduct: null,
      selectedBundles: [],
      selectedAttachments: [],
      giftAttachments: [],
      subtotal: 0,
      activeAccordion: null,
      expandSummary: false,
      leadTime: null,
      localizedVariants: false,
      tooltip: false,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    ...mapGetters({
      getComponentExists: 'components/getExists',
    }),

  },

  watch: {

    /**
     * Watch cart items to update focus trap.
     */
    'this.selectedProducts'() {
      this.overlay.update()
    },
  },

  mounted() {

    this.localizeProduct()
    if (!this.overlay.isActive) {
      return
    }

    this.overlay.update()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      addItem: 'cart/addItem',
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),

    /**
     * Handle selected variant
     * @param {Object} bundle -  selected variant.
     */
    handleVariantSelection(variant) {
      this.selectedProducts[0] = {
        id: variant.id,
        title: this.sanitizeTitle(variant.title),
        variant: this.sanitizeDescription(variant.title),
        quantity: 1,
        price: {
          amount: variant.price.amount,
        },
      }
      this.ships_in_text = variant.leadTime;
      this.selectedProduct = variant
      this.updateSubtotal()
    },

    /**
     * Handle selected bundle.
     * @param {Object} bundle -  selected bundle.
     */
    handleBundleSelection(bundle) {
      if (this.isSelectedBundle(bundle)) {
        const target = this.selectedBundles.findIndex(product => product.id === bundle.id)

        if (bundle.leadTime) {
          this.leadTime = null
        }

        this.selectedBundles.splice(target, 1)
        this.updateLineItems()
        return
      }

      if (bundle.leadTime) {
        this.leadTime = bundle.leadTime
      }

      this.selectedBundles.push({
        id: bundle.id,
        title: `${this.$string('product.sidebar.bundle')} - ${bundle.title}`,
        quantity: 1,
        price: {
          amount: bundle.price.amount,
        },
      })

      this.updateLineItems()
    },

    /**
     * Get variant description from variant title
     */
    handleAttachmentSelection(attachment, index) {
      if (this.isSelectedAttachment(attachment)) {
        if (attachment.hasOnlyDefaultVariant) {
          const target = this.selectedAttachments.findIndex((product) => {
            return product.id === attachment.selectedOrFirstAvailableVariant.id
          })

          this.selectedAttachments.splice(target, 1)
          this.updateLineItems()
          return
        }

        const target = this.selectedAttachments.findIndex((product) => {
          return product.id === attachment.variants[index].id
        })

        this.selectedAttachments.splice(target, 1)
        this.updateLineItems()
        return
      }

      if (attachment.hasOnlyDefaultVariant) {
        const data = {
          id: attachment.selectedOrFirstAvailableVariant.id,
          quantity: 1,
          title: attachment.title,
          price: attachment.selectedOrFirstAvailableVariant.price,
        }

        this.selectedAttachments.push(data)
        this.updateLineItems()
        return

      }

      const data = {
        id: attachment.variants[index].id,
        quantity: 1,
        title: attachment.title,
        price: attachment.variants[index].price,
        variant: attachment.variants[index].title,
      }

      this.selectedAttachments.push(data)
      this.updateLineItems()
    },
    handleGiftSelection(attachment, index) {
      if (this.isSelectedGift(attachment)) {
        if (attachment.hasOnlyDefaultVariant) {
          const target = this.selectedAttachments.findIndex((product) => {
            return product.id === attachment.selectedOrFirstAvailableVariant.id
          })

          this.selectedAttachments.splice(target, 1)
          this.updateLineItems()
          return
        }

        const target = this.selectedAttachments.findIndex((product) => {
          return product.id === attachment.variants[index].id
        })

        this.selectedAttachments.splice(target, 1)
        this.updateLineItems()
        return
      }

      if (attachment.hasOnlyDefaultVariant) {
        const data = {
          id: attachment.selectedOrFirstAvailableVariant.id,
          quantity: 1,
          title: attachment.title,
          price: 0,
          properties: {
            'Gift': 'Gift item'
          }
        }

        this.selectedAttachments.push(data)
        this.updateLineItems()
        return

      }

      const data = {
        id: attachment.variants[index].id,
        quantity: 1,
        title: attachment.title,
        price: 0,
        variant: attachment.variants[index].title,
        properties: {
            'Gift': 'Gift item'
          }
      }
      
      this.selectedAttachments.push(data)
      this.updateLineItems()
    },

    updateGiftSelection(attachment, index) {
      if (this.isSelectedGift(attachment)) {
        const newVariantValue = parseInt(this.$refs.selectedAttachmentVariant[index].value)
        const target = attachment.variants.findIndex(product => product.id === newVariantValue)

        this.selectedAttachments.splice(index)

        const data = {
          id: attachment.variants[target].id,
          quantity: 1,
          title: attachment.title,
          price: 0,
          variant: attachment.variants[target].title,
        }

        this.selectedAttachments.push(data)
        this.updateLineItems()
      }
    },
    updateAttachmentSelection(attachment, index) {
      if (this.isSelectedAttachment(attachment)) {
        const newVariantValue = parseInt(this.$refs.selectedAttachmentVariant[index].value)
        const target = attachment.variants.findIndex(product => product.id === newVariantValue)

        this.selectedAttachments.splice(index)

        const data = {
          id: attachment.variants[target].id,
          quantity: 1,
          title: attachment.title,
          price: attachment.variants[target].price,
          variant: attachment.variants[target].title,
        }

        this.selectedAttachments.push(data)
        this.updateLineItems()
      }
    },

    /**
     * Check if bundle is part of the selected bundles
     */
    isSelectedBundle(bundle) {
      let isSelected = false

      if (this.selectedBundles.length === 0) {
        return false
      }

      this.selectedBundles.forEach((selected) => {
        if (Object.values(selected).includes(bundle.id)) {
          isSelected = true
        }
      })

      return isSelected
    },

    /**
     * Check if attachment is part of the selected attachments
     */
     isSelectedGift(attachment) {
      let isSelected = false

      if (this.selectedAttachments.length === 0) {
        return false
      }

      this.selectedAttachments.forEach((selected) => {
        if (attachment.hasOnlyDefaultVariant &&
          selected.id === attachment.selectedOrFirstAvailableVariant.id
        ) {
          isSelected = true
          return isSelected
        }

        const match = attachment.variants.findIndex(product => product.id === selected.id)
        if (match >= 0) {
          isSelected = true
          return isSelected
        }
      })

      return isSelected
    },

    isSelectedAttachment(attachment) {
      let isSelected = false

      if (this.selectedAttachments.length === 0) {
        return false
      }

      this.selectedAttachments.forEach((selected) => {
        if (attachment.hasOnlyDefaultVariant &&
          selected.id === attachment.selectedOrFirstAvailableVariant.id
        ) {
          isSelected = true
          return isSelected
        }

        const match = attachment.variants.findIndex(product => product.id === selected.id)
        if (match >= 0) {
          isSelected = true
          return isSelected
        }
      })

      return isSelected
    },
    updateSubtotal() {
      let subtotal = 0
      this.selectedProducts.forEach((product) => {
        if (product?.price) {
          subtotal += product.price.amount
        }
        this.subtotal = subtotal
      })
    },

    updateLineItems() {
      let items = [this.selectedProduct]

      if (this.selectedBundles.length > 0) {
        items = [...items, ...this.selectedBundles]
      }

      if (this.selectedAttachments.length > 0) {
        items = [...items, ...this.selectedAttachments]
      }
      this.selectedProducts = items
      this.updateSubtotal()
    },

    /**
     * Increase or decrease buy flow steps
     */
    handleStepProgress(step) {
      if (step === 'next') {
        this.currentStep += 1
      }

      if (step === 'prev' && this.currentStep !== 1) {
        this.currentStep -= 1
      }
    },

    /**
     * Check variant type to associate type icon
     */
    getVariantType(title) {
      let type

      if (title.includes('gas')) {
        type = 'gas'
      }

      if (title.includes('electric')) {
        type = 'electric'
      }

      return type
    },

    /**
     * Split the sawmill engine power from variant title
     */
    sanitizeTitle(title) {
      return title.replace(')', '),').split(',').shift()
    },

    /**
     * Get variant description without samill engine power from variant title
     */
    sanitizeDescription(title) {
      return title.replace(')', '),').split(',').pop()
    },

    /**
     * Toggle active accordion.
     * @param {Number} targetIndex -  Index of an accordion.
     */
    toggleAccordion(targetIndex) {
      if (this.isActive(targetIndex)) {
        this.activeAccordion = false
        return
      }

      this.activeAccordion = targetIndex
    },

    /**
     * Check if an accordion is active.
     * @param {Number} index - Index of an accordion.
     */
    isActive(index) {
      return this.activeAccordion === index
    },

    /**
     * Handle adding items to cart
     */
    async handleAddToCart() {
      try {
       
            await this.addItem(this.selectedProducts);
          

        if (
          cnvs.settings.autoOpenCartDrawer &&
          this.getComponentExists('cart-drawer')
        ) {
          this.openOverlay({
            component: 'cart-drawer',
            ignoreDismissed: true,
            namespace: 'cartDrawer',
          })
          this.resetDrawer()
        }

      } catch (error) {
        cnvs.ReportError('Failed to add product to cart', error)
      }
    },

    /**
     * Track progress between purchase steps
     */
    getProgressPercent() {
      return `${(this.currentStep / this.steps) * 100}%`
    },

    /**
     * Reset states after items have been added to cart
     */
    resetDrawer() {
      this.currentStep = 1
      this.selectedProducts = []
      this.selectedProduct = null
      this.selectedBundles = []
      this.selectedAttachments = []
      this.giftAttachments= []
      this.subtotal = 0
    },

    /**
     * Handles buy box summary state
     */
    handleExpandSummary() {
      if (this.expandSummary) {
        this.expandSummary = false
        return
      }

      this.expandSummary = true
    },

    /**
     * Check product variants to see if any are exclusive to a separate market
     */
    localizeProduct() {
      const localizedVariants = []

      this.product.variants.forEach((el) => {
        if (!el?.exclusiveMarket) {
          localizedVariants.push(el)
        }

        if (el?.exclusiveMarket && this.isPartOfLocale(el)) {
          localizedVariants.push(el)
        }

        this.localizedVariants = localizedVariants
      })
    },

    /**
     * Check if an accordion is active.
     * @param {Object} product - product object.
     * check if product has exclusiveMarket param and it matches current locale
     */
    isPartOfLocale(product) {
      return product.exclusiveMarket.includes(window.cnvs.store.country.toLowerCase())
    },

    accessoryCount(length) {
      return this.$string('product.sidebar.included_accessories').replace('%accessory_count%', length)
    },
  },
}
</script>

<style lang="scss">
@import './product-form-drawer';
</style>
